
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/[code]",
      function () {
        return require("private-next-pages/restaurants/[code].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/[code]"])
      });
    }
  